import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ApiError, LocationViewParams, LocationViewResponse } from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<LocationViewResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchLocation = async ({ id }: LocationViewParams): Promise<LocationViewResponse> => {
    const url = apiEndpoints.locations.getSingle(id);
    const response = await api.get(url);
    return response?.data?.data;
};

const useLocation = (params: LocationViewParams, options?: QueryOptions) => {
    return useQuery<LocationViewResponse, ApiError>({
        queryKey: ['location', 'single', params],
        queryFn: () => fetchLocation(params),
        ...options,
        enabled: Boolean(params.id),
    });
};

export default useLocation;
